import { ThemeProvider } from '@mui/joy';
import { PropsWithChildren } from 'react';
import { lightTheme } from '../themes/light.theme.ts';
import { ConfigPageProvider } from '../providers/ConfigPageProvider.tsx';
import { DataFormPageProvider } from '../providers/DataFormPageProvider.tsx';
import { BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { QueryType } from '../lib/model.ts';
import { RouteProvider } from '../providers/RouteProvider.tsx';
import { YearProvider } from '../providers/YearProvider.tsx';
import { MenuLinksProvider, MenuLink } from '../providers/MenuLinksProvider.tsx';
import { PageContentProvider, PageContentContextInterface } from '../providers/PageContentProvider.tsx';
import { ErrorBoundary } from '../components/ErrorBoundary.tsx';

type WebComponentWrapperProps = PropsWithChildren & {
	dataFormProvider?: boolean;
	year?: number;
	menuLinks?: MenuLink[];
	landingPageLinks?: MenuLink[];
	pageContent?: Partial<PageContentContextInterface>;
	customFilterUrl?: string;
	ussenateData?: string;
	ussenateDataDonorMoney?: string;
	ushouseData?: string;
	ushouseDataDonorMoney?: string;
	ussenateDataDonorCont?: string;
	ushouseDataDonorCont?: string;
};

export const WebComponentWrapper = ({
	children,
	dataFormProvider,
	year,
	menuLinks,
	landingPageLinks,
	pageContent,
	customFilterUrl,
	ussenateData,
	ussenateDataDonorMoney,
	ushouseData,
	ushouseDataDonorMoney,
	ussenateDataDonorCont,
	ushouseDataDonorCont
}: WebComponentWrapperProps) => {
	return (
		<ErrorBoundary>
			<ThemeProvider theme={lightTheme}>
				<BrowserRouter>
					<QueryParamProvider
						adapter={ReactRouter6Adapter}
						options={{
							includeAllParams: true,
							params: QueryType
						}}
					>
						<YearProvider year={year}>
							<MenuLinksProvider
								menuLinks={menuLinks ? menuLinks : landingPageLinks ? landingPageLinks : [] as MenuLink[]}
								landingPageLinks={landingPageLinks ? landingPageLinks : menuLinks ? menuLinks : [] as MenuLink[]}
							>
								<RouteProvider>
									<ConfigPageProvider>
										<PageContentProvider
											introText={pageContent?.introText}
											highlights={pageContent?.highlights}
											methodology={pageContent?.methodology}
											dataAppendix={pageContent?.dataAppendix}
											lastUpdated={pageContent?.lastUpdated}
											sectionHeadings={pageContent?.sectionHeadings}
											ussenateData={ussenateData}
											ussenateDataDonorMoney={ussenateDataDonorMoney}
											ushouseData={ushouseData}
											ushouseDataDonorMoney={ushouseDataDonorMoney}
											ussenateDataDonorCont={ussenateDataDonorCont}
											ushouseDataDonorCont={ushouseDataDonorCont}
										>
											{dataFormProvider ? (
												<DataFormPageProvider customFilterUrl={customFilterUrl}>
													{children}
												</DataFormPageProvider>
											) : (
												children
											)}
										</PageContentProvider>
									</ConfigPageProvider>
								</RouteProvider>
							</MenuLinksProvider>
						</YearProvider>
					</QueryParamProvider>
				</BrowserRouter>
			</ThemeProvider>
		</ErrorBoundary>
	);
};
